// module.traffic (contract §4.8.1): TrafficModule (UnderwayModules.tsx): the
// vessels this boat's receiver hears, nearest first, one line each (name,
// range, speed, and age past two minutes), written out to the module's twenty
// slots; or its line while listening, in error, with no position fix or with
// none heard. The module draws no photos (§4.8.1); its note is the module
// card's (§6.2). The space between lines is each shown line's own, so an
// empty slot takes no room.

import { css, h } from "./kit.js";
import { F, R } from "./module-kit.js";

const SLOTS = 20;

export function moduleTraffic() {
  const rows = [];
  for (let k = 0; k < SLOTS; k += 1)
    rows.push(
      h(
        "li",
        { class: "tf-r" },
        h("span", { class: "tf-n", ...R("traffic-name", k) }),
        h(
          "span",
          { class: "tf-g" },
          h("b", R("traffic-range", k)),
          h("span", { class: "tf-u", ...R("traffic-range-unit", k) }),
        ),
        h(
          "span",
          { class: "tf-s" },
          h("span", R("traffic-sog", k)),
          h("span", { class: "tf-u", ...R("traffic-sog-unit", k) }),
        ),
        h("span", { class: "tf-a", ...R("traffic-age", k) }),
      ),
    );
  return {
    html: [
      h("i", { class: "mo-flag", ...F("state") }),
      h("p", { class: "mo-msg tf-m", ...F("message") }),
      h("ul", { class: "tf" }, rows),
    ],
    css: css(`
      .tf-m { color: var(--muted); }
      .mo-flag[data-state=error] ~ .tf-m, .mo-flag[data-state=no-position] ~ .tf-m {
        margin-top: 4px; font-size: 14px; font-weight: 600; }
      .tf { margin: 0; padding: 0; list-style: none; display: flex; flex-direction: column; }
      .tf-r + .tf-r > * { margin-top: 6px; }
      .tf-r { display: flex; align-items: baseline; gap: 10px; font-size: 15px; font-variant-numeric: tabular-nums; }
      .tf-n { flex: 1 1 60%; min-width: 0; overflow-wrap: anywhere; }
      .tf-n:empty, .tf-n:empty ~ * { display: none; }
      .tf-g { flex: none; white-space: nowrap; }
      .tf-g b { font-weight: 600; }
      .tf-s { flex: none; white-space: nowrap; color: var(--muted); }
      .tf-s span:empty { display: none; }
      .tf-u { margin-left: 0.2em; font-size: 12px; color: var(--muted); }
      .tf-a { flex: none; font-size: 12px; color: var(--muted); }
      .tf-a:empty { display: none; }
    `),
  };
}
